export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/#`;
export const servicePath = 'https://api.coloredstrategies.com';

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'cativa';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'default',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const ordinanceOptions = [
  { value: 'CRO/RN', label: 'CRO/RN' },
  { value: 'CRO/RJ', label: 'CRO/RJ' },
  { value: 'CRO/SC', label: 'CRO/SC' },
  { value: 'CRO/GO', label: 'CRO/GO' },
  { value: 'CRO/SE', label: 'CRO/SE' },
  { value: 'CRO/BA', label: 'CRO/BA' },
  { value: 'CRO/RS', label: 'CRO/RS' },
  { value: 'CRO/ES', label: 'CRO/ES' },
  { value: 'CRO/PR', label: 'CRO/PR' },
  { value: 'CRO/PA', label: 'CRO/PA' },
  { value: 'CFO', label: 'CFO' },
  { value: 'CRO/MG', label: 'CRO/MG' },
  { value: 'CRO/AP', label: 'CRO/AP' },
  { value: 'CRO/MS', label: 'CRO/MS' },
  { value: 'CRO/TO', label: 'CRO/TO' },
  { value: 'CRO/PI', label: 'CRO/PI' },
  { value: 'CRO/SP', label: 'CRO/SP' },
  { value: 'CRO/AC', label: 'CRO/AC' },
  { value: 'CRO/MT', label: 'CRO/MT' },
  { value: 'CRO/MA', label: 'CRO/MA' },
  { value: 'CRO/CE', label: 'CRO/CE' },
  { value: 'CRO/AM', label: 'CRO/AM' },
  { value: 'CRO/PB', label: 'CRO/PB' },
  { value: 'CRO/AL', label: 'CRO/AL' },
  { value: 'CRO/RR', label: 'CRO/RR' },
  { value: 'CRO/PE', label: 'CRO/PE' }
];

export const regulationTypeOptions = [
  { value: 'PORTARIA', label: 'Portaria' },
  { value: 'RESOLUCAO', label: 'Resolução' },
  { value: 'DECISAO', label: 'Decisão' },
  { value: 'REGIMENTO_INTERNO', label: 'Regimento Interno' },
  { value: 'LEI', label: 'Lei' }
];

export const statusOptions = [
  { value: 'ACTIVE', label: 'Ativo' },
  { value: 'INACTIVE', label: 'Inativo' }
];
